import postscribe from 'postscribe'
import 'whatwg-fetch'
import {service as AnalyticsService} from 'src/api/AnalyticsService'
import api from 'src/config/api'
import i18n from 'src/i18n'
import 'url-search-params-polyfill'

// BASE
const config = require('src/../config')
let base = __dirname
if (process.env.NODE_ENV === 'production') {
  base = config.build.assetsPublicPath
}

// SHARE IMAGE
const shareImg = require('src/assets/share2.jpg')



// SHARE SERVICE
class ShareService {

  constructor(analytics) {
    this.analytics = analytics
    this.lastUrl = null
    this.injected = false
    this.inWechat = /micromessenger/i.test(navigator.userAgent)
    // this.init()

    this.debugEnabled = new window.URLSearchParams(window.location.search).get('_wechatDebug') !== null

  }


  init = ()=> {
    return this.injectScript()
      .then(this.updateConfig)
      .then(this.enableShare)
      // .then(this.setDefaultLink)
  }


  injectScript () {


    return new Promise((resolve, reject)=> {

      if (this.injected) {
        resolve()
        return
      }
      this.injected = true

      if (!this.inWechat) {
        resolve()
        return
      }

      const head = document.head || document.getElementsByTagName('head')[0]
      const src = '//res.wx.qq.com/open/js/jweixin-1.0.0.js'
      postscribe(head, `<script src='${src}'></script>`, {
        afterAsync: ()=> {
          resolve()
        }
      })
    })
  }


  updateConfig = ()=> {

    return new Promise((resolve)=> {

      if (!this.inWechat) {
        resolve()
        return
      }

      // let configUrl = 'https://api.nike.com.cn/wx/v3/js/share/oa/jdi/'
      let configUrl = `${api.endpoints.shareConfig}`

      if (this.lastUrl === encodeURIComponent(window.location.href.split('#')[0])) {
        resolve()
        return
      }

      this.lastUrl = encodeURIComponent(window.location.href.split('#')[0])

      const requestUrl = `${configUrl}?link=${this.lastUrl}`

      window.fetch(requestUrl)
        .then((response)=> {
          return response.json()
        })
        .then((json)=> {
          return this.handleConfigSuccess(json)
        })
        .then(()=> {
          resolve()
        })
    })

  }

  handleConfigSuccess = (config)=> {
    return new Promise((resolve)=> {

      if (!window.wx) return resolve()

      window.wx.config({
        debug: this.debugEnabled,
        appId: config.appId,
        timestamp: config.timestamp,
        nonceStr: config.nonceStr,
        signature: config.signature,
        jsApiList: [
          'checkJsApi',
          'onMenuShareTimeline',
          'onMenuShareAppMessage',
          'hideMenuItems',
          'showMenuItems'
        ]
      })
      window.wx.ready(resolve)
    })

  }

  enableShare = ()=> {
    // console.log('enableShare')
    return new Promise((resolve)=> {

      if (!this.inWechat) {
        resolve()
        return
      }

      window.wx.showMenuItems({
        menuList: [
          'menuItem:share:appMessage',
          'menuItem:share:timeline',
          'menuItem:share:qq',
          'menuItem:share:weiboApp',
          'menuItem:share:facebook'
        ]
      })
      resolve()
    })

  }

  disableShare = ()=> {
    // if (!window.wx) return
    window.wx.hideMenuItems({
      menuList: [
        'menuItem:share:appMessage',
        'menuItem:share:timeline',
        'menuItem:share:qq',
        'menuItem:share:weiboApp',
        'menuItem:share:facebook'
      ]
    })
  }

  setLink = (path, title = '', desc = '', moments = '', shareImg)=> {

    // console.log('setLink', path, title, desc, moments, shareImg)

    // return this.updateConfig()
    //   .then(()=> {

      // const base = window.location.href.split('#')[0].split('?')[0]
    const base = window.location.origin
    const link = `${base}${path}`
    const img = `${base}${shareImg}`

    // console.log(shareImg, img)

    if (!this.inWechat) {
      // resolve()
      return
    }

    window.wx.onMenuShareTimeline({
      link: link,
      title: moments,
      imgUrl: img,
      success: ()=> {
        AnalyticsService.sendEvent('share', 'onMenuShareTimeline')
      }
    })

    window.wx.onMenuShareAppMessage({
      link: link,
      title: title,
      desc: desc,
      imgUrl: img,
      success: ()=> {
        AnalyticsService.sendEvent('share', 'onMenuShareAppMessage')
      }
    })

      // })

  }

  setDefaultLink = ()=> {
    return this.setLink(
      `${base}`,
      i18n.t('wechat.generic.title'),
      i18n.t('wechat.generic.desc'),
      i18n.t('wechat.generic.moments'),
      shareImg
    )
  }

  setResultLink = (duration, username)=> {

    let link = `${base}result?_duration=${duration}`
    if (username) {
      link += `&_name=username`
    }

    console.log('ShareService.setResultLink', link)

    return this.setLink(
      link,
      i18n.t('wechat.result.title'),
      i18n.t('wechat.result.desc'),
      i18n.t('wechat.result.moments'),
      shareImg
    )
  }


}


export let service = new ShareService()
window.ShareService = service
export default service




// WEBPACK FOOTER //
// ./src/api/ShareService.js